import { Header } from '../../components/atoms';
import { HeadContent, Toast } from '../../components';
import { RedefinePassword } from './partials/RedefinePassword';

export default function RedefinePasswordTemplate() {
  return (
    <>
      <HeadContent
        metaTitle="GetNinjas | Orçamento de Profissionais Confiáveis no GetNinjas.com.br"
        slug=""
        metaDescription=""
        type="forgot-password:show"
        noindex
      />
      <Header.Simple />
      <RedefinePassword />
      <Toast />
    </>
  );
}
